module.exports = __webpack_public_path__ + "img/10890_L.a262c2a7.png";